import React from "react";
import CptShimmerBlock from "../common/CptShimmerBlock";

const CptRowShimmer = ({ enrollment = false, previous = false }) => (
  <div
    className={`component-performance-cpt-card mpr-shimmer-cpt-shell${
      enrollment ? ` enrollment-cpt-card-${previous ? "previous" : "current"}` : ""
    }`}
  >
    {enrollment && <CptShimmerBlock className="mpr-shimmer-enrollment-label" />}
    <CptShimmerBlock className="mpr-shimmer-cpt-code" />
    <CptShimmerBlock className="mpr-shimmer-cpt-title" />
    <div className="component-performance-kpi-strip mpr-shimmer-kpi-strip-shell">
      <div className="component-performance-kpi-strip-left">
        <CptShimmerBlock className="mpr-shimmer-kpi-tag" />
        <CptShimmerBlock className="mpr-shimmer-kpi-count" />
      </div>
      <CptShimmerBlock className="mpr-shimmer-kpi-btn" />
    </div>
  </div>
);

const ComponentPerformanceCardShimmer = ({ variant = "standard" }) => {
  const isEnrollment = variant === "enrollment";

  return (
    <div className="component-performance-card-modern mpr-shimmer-shell-card">
      <div className="component-performance-card-header">
        <div className="component-performance-header-left">
          <CptShimmerBlock className="mpr-shimmer-cp-header-icon" />
          <CptShimmerBlock className="mpr-shimmer-cp-header-title" />
        </div>
      </div>

      {!isEnrollment && (
        <div className="component-performance-child-kpis">
          <CptShimmerBlock className="mpr-shimmer-kpi-cell" />
          <CptShimmerBlock className="mpr-shimmer-kpi-cell" />
          <CptShimmerBlock className="mpr-shimmer-kpi-cell" />
        </div>
      )}

      <div
        className={`component-performance-cpt-list${
          isEnrollment ? " component-performance-cpt-list-enrollment" : ""
        }`}
      >
        <CptRowShimmer enrollment={isEnrollment} />
        <CptRowShimmer enrollment={isEnrollment} previous />
      </div>
    </div>
  );
};

export default ComponentPerformanceCardShimmer;
